import DemoVideo from '../shared/DemoVideo';

/**
 * Fica entre o PRStatsBand e o PRPipeline: depois dos números a pergunta
 * natural é "como assim?", e o vídeo responde mostrando; a seção seguinte
 * então destrincha as etapas. Invertido, a explicação viria antes da
 * demonstração e o vídeo soaria repetido.
 */
export default function PRDemo() {
  return (
    <DemoVideo
      i18nKey="pr.demo"
      base="/assets/pixrow-demo-v1"
      poster="/assets/pixrow-demo-poster-v1.jpg"
    />
  );
}
